module.exports = __webpack_public_path__ + "img/wave-1.87a712da.svg";